// extracted by mini-css-extract-plugin
export default {"color-group":"ColorInput_color-group__0nXfc","input-color-container":"ColorInput_input-color-container__oJIy4","input-color":"ColorInput_input-color__qRdnI"};